var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "What We Do",
      "tabActive": "Overview",
      "bg": "/images/sub/visual/sv4.png"
    }
  }), _c('section', {
    staticClass: "sub-section--first sub-section--last"
  }, [_c('v-container', [_c('h2', {
    staticClass: "page-tit"
  }, [_vm._v(" Overview ")]), _c('overview', {
    attrs: {
      "src": "/images/sub/wwd/overview/overview-img1.png",
      "icon": "/images/sub/wwd/overview/overview-icon1.png",
      "iconWidth": "67",
      "num": "01",
      "tit": "고객상담"
    }
  }, [_vm._v(" 고객의 아이디어를 반영한 맞춤 제작을 통해 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 최적의 방법으로 제품 생산이 가능한 방안을 제시해 드립니다. ")]), _c('overview', {
    attrs: {
      "className": "reverse",
      "src": "/images/sub/wwd/overview/overview-img2.png",
      "icon": "/images/sub/wwd/overview/overview-icon2.png",
      "iconWidth": "55",
      "num": "02",
      "tit": "설계 및 소재 선정"
    }
  }, [_vm._v(" 반도체 부품 분야에서 핵심 역량을 다져온 기술력을 바탕으로, 구조 특성을 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 이해한 설계 및 다양한 소재의 선정을 통한 제품 커스텀 마이징이 가능합니다. ")]), _c('overview', {
    attrs: {
      "src": "/images/sub/wwd/overview/overview-img3.png",
      "icon": "/images/sub/wwd/overview/overview-icon3.png",
      "iconWidth": "54",
      "num": "03",
      "tit": "정밀 가공"
    }
  }, [_vm._v(" 다양한 정밀 가공 설비를 활용한 순차적 가공 프로세스를 거친 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 퀄리티 높은 상품을 생산합니다. ")]), _c('overview', {
    attrs: {
      "className": "reverse",
      "src": "/images/sub/wwd/overview/overview-img4.png",
      "icon": "/images/sub/wwd/overview/overview-icon4.png",
      "iconWidth": "54",
      "num": "04",
      "tit": "정밀 연마"
    }
  }, [_vm._v(" 정밀 연마 가공을 통해 고객이 원하는 최적의 제품을 생산합니다. "), _c('br'), _vm._v(" (CMP 공정에 특화된 연마 공정) ")]), _c('overview', {
    attrs: {
      "src": "/images/sub/wwd/overview/overview-img5.png",
      "icon": "/images/sub/wwd/overview/overview-icon5.png",
      "iconWidth": "54",
      "num": "05",
      "tit": "품질 검사"
    }
  }, [_vm._v(" 3D 측정기, 정밀 조도 측정기, 마이크로 스코프 등 품질 관리에 필요한 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 측정기를 보유하고 있으며, SPC를 통한 주기적인 트렌드 분석 및 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 제품 관리에 엄격히 진행하고 있습니다. ")]), _c('overview', {
    attrs: {
      "className": "reverse",
      "src": "/images/sub/wwd/overview/overview-img6.png",
      "icon": "/images/sub/wwd/overview/overview-icon6.png",
      "iconWidth": "55",
      "num": "06",
      "tit": "적용 테스트"
    }
  }, [_vm._v(" 내·외부 설비를 이용한 검증 테스트 후, 고객사 내부 테스트를 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 진행하여 제품이 적합 여부를 확인합니다. ")]), _c('overview', {
    attrs: {
      "src": "/images/sub/wwd/overview/overview-img7.png",
      "icon": "/images/sub/wwd/overview/overview-icon7.png",
      "iconWidth": "54",
      "num": "07",
      "tit": "고객 제품 양산"
    }
  }, [_vm._v(" 고객이 요구하는 제품의 품질 및 납기를 위해 최선을 다합니다 ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }